import authorize from './authorize';
import token from './token';
import status from './status';
import numberSeries from './numberSeries';

export default {
  authorize,
  token,
  status,
  numberSeries,
};



// WEBPACK FOOTER //
// ./src/app/services/unimicro/index.js